import React from 'react';
import { motion } from 'framer-motion';
import Logo from "../assets/Logo"; 

const PaymentInstruction = ({ amount, currency, logoUrl }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      className="max-w-lg  z-0 mx-auto   rounded-lg  p-6 md:p-8 lg:p-12 relative"
    >
		
            {/* Payment Instructions */}
      <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center">Payment Instructions</h2>
      
      <p className="text-sm md:text-lg mb-4 text-center font-light">
        Please ensure that you send the exact amount listed below to complete your payment.
        Double-check the details before proceeding to avoid any issues.
      </p>

      {/* Payment Amount */}
      <div className="bg-white text-blue-600 font-bold rounded-lg shadow-md p-4 text-center mb-6">
        <p className="text-lg md:text-xl">Amount to Pay:</p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-3xl md:text-4xl font-bold mt-2"
        >
          {amount} {currency}
        </motion.div>
      </div>

      {/* Key Reminders */}
      <motion.ul
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.3 }}
        className="space-y-2 md:space-y-4 text-xs md:text-base text-center"
      >
        <li>🔒 Ensure the address matches exactly.</li>
        <li>⏱ Payments can take a few minutes to confirm.</li>
        <li>💸 Avoid underpaying to ensure successful processing.</li>
      </motion.ul>

      {/* Footer Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.6 }}
        className="text-center mt-8 text-xs md:text-sm text-gray-300"
      >
        Thank you for using our service! Contact support if you face any issues.
      </motion.div>

      {/* Custom Background Gradients */}
    </motion.div>
  );
};

export default PaymentInstruction;

